import React from 'react';
import { Dialog, DialogContent, DialogContentText, DialogActions, Button ,Backdrop,CircularProgress} from '@mui/material';
import axios from 'axios';
import { ACR, BASE_URL, WFMT_POST_REQUEST } from '../../constant/urls';


const WfmtDialog = ({ job_type,open, onClose,jobList,sau,exch_sau ,setSnackMsg,setAlertOpen,setAlertsucessOpen,accounts,handleOpen}) => {
    const [loading, setLoading] = React.useState(false);
     const handleTriggerWfmt = () => {
        onClose();
        setLoading(true);

        const wfmtposturl = `${BASE_URL}/${ACR}/${WFMT_POST_REQUEST}`;
        const data = jobList ? jobList[0] : null
        const wfmtdata = {
            "jobid": data?.job_id,
            "exchange": exch_sau,
            "sau": sau,
            "cable_id": data?.recoverable_cable,
            "job_type": job_type,
            "planner_ein": accounts[0]?.idTokenClaims.EIN
        }
        axios.post(wfmtposturl, wfmtdata,)
            .then((res) => {
                res.data.status.toLowerCase() === "fail" && (() => {
                    setSnackMsg(res.data.MESSAGE);
                    setAlertOpen(true);
                    setLoading(false);
                    onClose();

                })()
                res.data.status.toLowerCase() === "success" && (() => {
                    setSnackMsg(res.data.MESSAGE);
                    setAlertsucessOpen(true);
                     handleOpen()
                    setLoading(false);
                    
                })()
            })
            .catch((error) => {
                setSnackMsg("Something went wrong.Try Again!!");
                setAlertOpen(true);
                setLoading(false);
            })
    }
    
    return (
        <>     
           <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirmation-modal-title"
            aria-describedby="confirmation-modal-description"
            sx={{ marginTop: "-400px" }}
            id='wfmt-dialog'
        >
            <DialogContent>
                <DialogContentText id="confirmation-modal-description">
                    Do you want to proceed with triggering WFMT?
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button
                id='wfmt-ok-button'
                    variant="contained"
                    style={{
                        color: "white",
                        backgroundColor: "rgb(2, 2, 81)",
                        fontSize: "12px",
                        height: "30px",
                        margin: "0px 0px 9px",
                        width: "50px",
                    }}
                    onClick={handleTriggerWfmt}
                >
                    YES
                </Button>
                <Button
                id='wfmt-cancel-button'
                    style={{
                        color: "white",
                        backgroundColor: "rgb(2, 2, 81)",
                        fontSize: "12px",
                        height: "30px",
                        margin: "0px 10px 9px",
                        width: "50px",
                    }}
                    onClick={onClose}
                >
                    NO
                </Button>
            </DialogActions>
        </Dialog>
        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
        
    );
};

export default WfmtDialog;